// src/utils/kioskPhotoApi.js
//
// The kiosk background photo library (backend routes/kioskPhotos.ts,
// admins only). Errors carry the backend's code in err.message
// (WRONG_SIZE, NOT_BASELINE, TOO_BIG, ...).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const BASE = `${API_BASE_URL}/admin/kiosk-photos`;

async function call(method, path, token, body, contentType = 'application/json') {
  const r = await fetch(`${BASE}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': contentType } : {}) },
    body: body == null ? undefined : (contentType === 'application/json' ? JSON.stringify(body) : body),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const listPhotos = (token) => call('GET', '', token);
export const uploadPhoto = (blob, name, token) => call('POST', `?name=${encodeURIComponent(name)}`, token, blob, 'image/jpeg');
export const renamePhoto = (id, name, token) => call('PUT', `/${id}`, token, { name });
export const setDefaultPhoto = (id, token) => call('PUT', `/${id}/default`, token, {});
export const deletePhoto = (id, token) => call('DELETE', `/${id}`, token);
export const assignPhoto = (targetType, targetId, photoId, token) => call('PUT', '/assignments', token, { targetType, targetId, photoId });
export const listTerritories = (token) => call('GET', '/territories', token);
export const searchFacilities = (q, token) => call('GET', `/facilities?q=${encodeURIComponent(q)}`, token);
export const resolvePhoto = (facilityId, token) => call('GET', `/resolve/${facilityId}`, token);

const ERRORS = {
  WRONG_SIZE: 'La photo doit faire exactement 800×480 pixels.',
  NOT_BASELINE: 'Format JPEG non lisible par la borne (JPEG progressif).',
  NOT_A_JPEG: 'Ce fichier n’est pas une image JPEG.',
  TOO_BIG: 'Photo trop lourde (100 Ko au maximum).',
  PHOTO_NOT_FOUND: 'Cette photo n’existe plus.',
  TARGET_NOT_FOUND: 'Zone ou établissement introuvable.',
  FACILITY_NOT_FOUND: 'Établissement introuvable.',
};
export const photoErrorText = (err) => ERRORS[err?.message] ?? 'Une erreur est survenue, réessayez.';

// Kiosk settings (backend routes/kioskSettings.ts): weather on the home screen.
const SETTINGS = `${API_BASE_URL}/admin/kiosk-settings`;
async function settingsCall(method, path, token, body) {
  const r = await fetch(`${SETTINGS}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP_${r.status}`);
  return data;
}
export const getKioskSettings = (token) => settingsCall('GET', '', token);
export const setWeatherDefault = (on, token) => settingsCall('PUT', '', token, { weatherDefault: on });
export const setDemoFacilities = (facilityIds, token) => settingsCall('PUT', '', token, { demoFacilityIds: facilityIds });
export const setFacilityWeather = (facilityId, weather, token) => settingsCall('PUT', `/facility/${facilityId}`, token, { weather });
